import { MenuAppInstance, MenuAppType } from "@/entities/app/menu/menu.types"

import { APIDocsSwagger } from "../APIStable"

type Company = {
  _id: string
}

type Location = {
  _id: string
  company?: Company
}

type Screen = {
  _id: string
  appId: string
  name?: string
  company?: Company
  location: Location | string
}

type Design = {
  _id: string
  [key: string]: unknown
}

type Event = {
  name?: string
  description?: string
  recurrence?: string
  start_time?: string
  end_time?: string
  specific_days?: string[]
  specific_start_date?: string
  specific_end_date?: string
  designId?: string | Design | null
}

type MenuAppInstanceSchema1 = {
  _id: string
  screen: Screen
  type: MenuAppType | string
  events: Event[]
  company: string | Company
}

type MenuAppInstanceSchema = Partial<typeof APIDocsSwagger.schemas.Screen._plain> & Partial<typeof APIDocsSwagger.schemas.MenuApp._plain> & Partial<MenuAppInstanceSchema1>

export function mapMenuAppInstance(schema: MenuAppInstanceSchema): MenuAppInstance {
  const firstEventDesignId = schema?.events?.[0]?.designId
  const designId = typeof firstEventDesignId === "string"
    ? firstEventDesignId
    : (typeof firstEventDesignId === "object" && firstEventDesignId !== null && "_id" in firstEventDesignId
      ? (firstEventDesignId as Design)._id
      : null)

  return {
    type: (schema.type as MenuAppType) ?? MenuAppType.MENU,
    name: schema.appId ?? schema.screen?.appId ?? "unknown", // Baptized as "name" in MenuAppInstance
    label: schema.name ?? schema.screen?.name ?? "", // Baptized as "name" in MenuAppInstance

    id: schema._id ?? "unknown",
    designId,

    companyId: typeof schema.company === "string"
      ? schema.company
      : (typeof schema.company === "object" && schema.company !== null && "_id" in schema.company
        ? (schema.company as Company)._id
        : (schema.screen?.company?._id ?? schema.screen?.location?.company?._id ?? "unknown")),
    locationId: typeof schema.screen?.location === "string"
      ? schema.screen?.location
      : (schema.screen?.location?._id ?? "unknown"),

    events: schema.events?.map(event => ({
      name: event.name ?? "",
      description: event.description ?? "",
      recurrence: (event.recurrence as "daily" | "specific_days" | "specific_dates") ?? "daily",
      start_time: event.start_time ?? "",
      end_time: event.end_time ?? "",
      specific_days: event.specific_days,
      specific_start_date: event.specific_start_date,
      specific_end_date: event.specific_end_date,
      designId: typeof event.designId === "string"
        ? event.designId
        : (typeof event.designId === "object" && event.designId !== null && "_id" in event.designId
          ? (event.designId as Design)._id
          : undefined)
    }))
  }
}
